export default __webpack_public_path__ + "09d89a6e6973630e90da92965e3edcb8.svg";